"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarType = exports.SideBarStatus = exports.ARIA_LABEL = exports.ARIA_LABEL_BARRA_CONTRAER = exports.ARIA_LABEL_BARRA_EXPANDIR = exports.SIDE_BAR_BUTTON_NAV = exports.SIDE_BAR_LI_NAV = exports.SIDE_BAR_ID = exports.SIDE_BAR_CONTENT_QUERY = exports.SIDE_BAR_ARIA_CONTROL = exports.SIDE_BAR_BUTTONS_QUERY = exports.SIDE_BAR_PRINCIPAL_CONTENT = exports.SIDE_BAR_ASIDE = exports.SIDE_BAR_TYPE_PROPERTY = exports.SIDE_BAR_STATUS_PROPERTY = exports.CLOSE_BUTTON_TEXT = exports.SIDE_BAR_ACTIVE_ITEM = exports.SIDE_BAR_ACTIVE_CONTENT = exports.SIDE_BAR = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.SIDE_BAR = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-sidebar");
exports.SIDE_BAR_ACTIVE_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-sidebar-active-content");
exports.SIDE_BAR_ACTIVE_ITEM = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-sidebar-active-item");
exports.CLOSE_BUTTON_TEXT = 'error';
exports.SIDE_BAR_STATUS_PROPERTY = 'status';
exports.SIDE_BAR_TYPE_PROPERTY = 'type';
exports.SIDE_BAR_ASIDE = ':scope>aside';
exports.SIDE_BAR_PRINCIPAL_CONTENT = ':scope>section:first-child>div:first-child';
exports.SIDE_BAR_BUTTONS_QUERY = ':scope>aside>section:first-child>section:first-child>button';
exports.SIDE_BAR_ARIA_CONTROL = '';
exports.SIDE_BAR_CONTENT_QUERY = ':scope>aside>section:first-child>section:nth-child(2)>div';
exports.SIDE_BAR_ID = 'id';
exports.SIDE_BAR_LI_NAV = ':scope>aside>nav>ul>li';
exports.SIDE_BAR_BUTTON_NAV = ':scope>aside>nav>ul:first-child>li>button';
exports.ARIA_LABEL_BARRA_EXPANDIR = 'Expandir barra lateral';
exports.ARIA_LABEL_BARRA_CONTRAER = 'Contraer barra lateral';
exports.ARIA_LABEL = 'aria-label';
var SideBarStatus;
(function (SideBarStatus) {
    SideBarStatus["close"] = "close";
    SideBarStatus["open"] = "open";
})(SideBarStatus = exports.SideBarStatus || (exports.SideBarStatus = {}));
var SideBarType;
(function (SideBarType) {
    SideBarType["fixed"] = "fixed";
    SideBarType["hide"] = "hide";
    SideBarType["collapsible"] = "collapsible";
    SideBarType["states"] = "states";
})(SideBarType = exports.SideBarType || (exports.SideBarType = {}));
